import FilterSidebar from "../filterSidebar.comp";
import AdjustmentIcon from "../../icons/adjustment.icon";
import XMarkIcon from "../../icons/xMark.icon";
import { useTranslation } from "../../core/translation.core";

interface BrandOption {
  id: string;
  name: string;
  count: number;
  code: string;
}

interface ApiAttributeOption {
  attribute_id: string;
  value: string;
  count: number;
}

interface FilterState {
  attrs: { [key: string]: string[] };
  priceRange: { min: number; max: number };
  selectedBrands: string[];
}

interface ResponsiveFilterSidebarProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  className?: string;
  onDiscountChange: (checked: boolean) => void;
  onFilterUpdate: (filters: FilterState) => void;
  brandOptions: BrandOption[];
  attributeOptions: ApiAttributeOption[];
}

export function FilterOpenButton({ onClick }: { onClick: () => void }) {
  const { t, msg } = useTranslation();

  return (
    <button
      onClick={onClick}
      className="md:hidden flex items-center gap-2 px-3 py-2 bg-neutral-100 hover:bg-neutral-200 rounded-lg transition-colors"
      aria-label={t(msg.common.filter)}
    >
      <AdjustmentIcon className="w-5 h-5 text-gray-700" />
      <span className="text-sm text-gray-700">{t(msg.common.filter)}</span>
    </button>
  );
}

export function ResponsiveFilterSidebar({
  isOpen,
  onOpenChange,
  title,
  className = "",
  onDiscountChange,
  onFilterUpdate,
  brandOptions,
  attributeOptions,
}: ResponsiveFilterSidebarProps) {
  return (
    <>
      {isOpen && (
        <div
          className="md:hidden fixed inset-0 z-[90] bg-black bg-opacity-50"
          onClick={() => onOpenChange(false)}
          aria-hidden="true"
        />
      )}
      <aside
        className={`fixed inset-y-0 left-0 z-[100] w-full max-w-xs bg-white shadow-xl flex flex-col transition-transform duration-300 ease-in-out md:relative md:translate-x-0 md:shadow-none md:max-w-none md:w-auto md:z-auto ${isOpen ? "translate-x-0" : "-translate-x-full"} ${className}`}
      >
        <div className="md:hidden flex items-center justify-between px-4 py-4 border-b border-gray-200 shrink-0">
          <h2 className="text-lg font-medium text-gray-800">{title}</h2>
          <button onClick={() => onOpenChange(false)} aria-label="Close">
            <XMarkIcon className="w-6 h-6 text-gray-500" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 md:p-0 md:overflow-visible">
          <FilterSidebar
            onDiscountChange={onDiscountChange}
            onFilterUpdate={onFilterUpdate}
            brandOptions={brandOptions}
            attributeOptions={attributeOptions}
            expanded
          />
        </div>
      </aside>
    </>
  );
}
